import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";

const inputClass =
  "w-full bg-ink border border-border text-white placeholder:text-slatetxt/60 px-4 py-3.5 text-sm outline-none focus:border-brand focus:ring-1 focus:ring-brand transition-colors";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("tfs_admin_token")) navigate("/admin");
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("tfs_admin_token", data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <img src="/brand/tfs-logo-white.png" alt="TFS" className="h-12 w-auto" />
        </div>
        <div className="bg-surface border border-border p-8">
          <div className="flex items-center gap-3 mb-6">
            <Lock size={20} className="text-brand-light" />
            <h1 className="font-display font-bold text-2xl text-white tracking-tight">Enquiries Login</h1>
          </div>
          <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block text-xs uppercase tracking-[0.15em] text-slatetxt mb-2">Email</label>
              <input data-testid="admin-email" type="email" className={inputClass} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="mail@tfservices.co.uk" />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.15em] text-slatetxt mb-2">Password</label>
              <input data-testid="admin-password" type="password" className={inputClass} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-hover disabled:opacity-60 text-white font-semibold px-6 py-3.5 transition-colors"
            >
              {loading && <Loader2 size={18} className="animate-spin" />} Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
